import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";

import { apiEndpoints } from "../../config";

import PostSingle from "../../partials/posts/postSingle";
import { patchNode, postNode } from "../../core/postNode";
import { getOnlineNode } from "../../core/getNode";
import AlertModal from "../../partials/alertModal";

import { Typography, Button, Alert } from "@mui/material";

export default function QuizSingle(props) {
  const [post, setPost] = useState(null);
  const [quizEntityAnswers, setQuizEntityAnswers] = useState([]);
  const [questionCompletion, setQuestionCompletion] = useState({});
  const [submission, setSubmission] = useState(null);
  const [quizProgress, setQuizProgress] = useState([]);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const user = useSelector((state) => state).authReducer.user;

  const handleQuestionComplete = useCallback((blockId, isComplete) => {
    setQuestionCompletion((prev) => ({ ...prev, [blockId]: isComplete }));
  }, []);

  const allQuestionsComplete =
    Object.keys(questionCompletion).length > 0 &&
    Object.values(questionCompletion).every(Boolean);

  useEffect(() => {
    if (!post) return;
    getSubmission();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [post]);

  const quizUpdate = (payload) => {
    const uid = user.current_user.uid;
    patchNode(`/api/v3/quiz/progress/${uid}`, payload, user.csrf_token)
      .then((response) => {
      })
      .catch((_error) => {
        console.error(_error);
      });
  };

  const getQuizProgress = () => {
    const uid = user.current_user.uid;
    getOnlineNode(`/api/v3/quiz/progress/${uid}?id=${post.id}&_format=hal_json`)
      .then((response) => {
        setQuizProgress(response.data ?? []);
      })
      .catch((err) => {
        console.error("quiz error progress", err);
      });
  };

  const getSubmission = () => {
    if (post) {
      getOnlineNode(
        `${apiEndpoints.quizSubmission}?quiz_id=${post.id}&uid=${user.current_user.uid}?_format=json`,
      )
        .then((response) => {
          setSubmission(response.data);
          getQuizProgress(); // has submission, but keep symmetry if you want progress anyway — see note below
        })
        .catch((err) => {
          const status = err?.status ?? err?.response?.status;
          if (status === 404) {
            // no submission yet — this is the expected "not submitted" case
            setSubmission(null);
            getQuizProgress();
            return;
          }
          console.error(err);
        });
    }
  };

  const submitQuiz = () => {
    if (post) {
      const data = {
        quiz_id: post?.id,
        field_question: quizEntityAnswers,
      };

      postNode(apiEndpoints.quizSubmission, data, user.csrf_token)
        .then((response) => {
          setSubmission(response);
          window.location.reload();
        })
        .catch((err) => {
          console.error("submit quiz error", err);
        });
    }
  };

  return (
    <PostSingle
      preview={props.preview}
      apiEndpoint={apiEndpoints.quiz}
      featuredImageEnabled={true}
      entityFavoritesContentType={"quiz"}
      previewReturnRoute={"/quizzes-creator"}
      returnRoute={"/quizzes"}
      backBtnText={"Quiz Library"}
      screenClassName={"quizzes"}
      v2Bundle={"quiz"}
      logCustomEventType={"Quiz"}
      entityType={"quiz"}
      disableReactions={true}
      setEntityPost={(_post) => {
        setPost(_post);
      }}
      setQuizEntityAnswers={(answers) => setQuizEntityAnswers(answers)}
      quizEntitySubmission={submission}
      quizProgress={quizProgress}
      quizUpdate={(payload) => {
        quizUpdate(payload);
      }}
      onComplete={handleQuestionComplete}
      childrenAfter={
        <>
          {post &&
            submission === null &&
            post.allow_submission &&
            user?.current_user && (
              <Button
                disabled={!allQuestionsComplete}
                variant="contained"
                onClick={() => {
                  setShowConfirmation(true);
                }}
              >
                <Typography owner="client" variant="button" singles={true}>
                  Submit
                </Typography>
              </Button>
            )}
        </>
      }
    >
      {submission && (
        <Alert
          className="ps-4"
          owner="client"
          severity="success"
          sx={{
            "& .MuiAlert-icon": {
              padding: "7px 0px 7px 9px",
            },
          }}
        >
          <Typography owner="client" variant="body1" weight="light">
            You have completed the quiz
          </Typography>
        </Alert>
      )}
      {!post?.allow_submission && (
        <Alert
          className="ps-4"
          owner="client"
          severity="info"
          sx={{
            "& .MuiAlert-icon": {
              padding: "7px 0px 7px 9px",
            },
          }}
        >
          <Typography owner="client" variant="body1" weight="light">
            This quiz does not require submission
          </Typography>
        </Alert>
      )}
      <AlertModal
        warningIcon
        showAlert={showConfirmation}
        alertMessageTitle={`Important`}
        alertMessageBody={
          "Once submitted you can no longer change your answers for this test"
        }
        showAlertCallback={setShowConfirmation}
        confirmButton={true}
        confirmButtonLabel={"Submit"}
        onConfirm={() => {
          submitQuiz();
        }}
        cancelButton={true}
      />
    </PostSingle>
  );
}
